import { api } from './api';

export const fetchOrganizationById = (id) => {
  return api.get(`/organization/${id}`);
};

export const fetchUpdateOrganization = (id, data) => {
  return api.put(`/organization/${id}`, data);
};

export const fetchPublicOrganizations = () => {
  return api.get('/organization/public');
};

export const uploadLogo = (id, formData) => {
  return api.post(`/organization/${id}/logo`, formData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
};

export const deleteOrganizationLogo = (id) => {
  return api.delete(`/organization/${id}/logo`);
};

export const getAvailablesBrokers = (params) => {
  return api.get(`/organization/brokers`, params);
};

export const fetchDeleteOrganizationsToBrokers = (org_to_broker_id) => {
  return api.delete(`/organization/brokers/${org_to_broker_id}`);
};

export const editOrganizationsToBrokers = (org_to_broker_id, payload) => {
  return api.put(`/organization/brokers/${org_to_broker_id}`, payload);
};

export const fetchOrganizationToBrokerById = (org_to_broker_id) => {
  return api.get(`/organization/brokers/${org_to_broker_id}`);
};

export const fetchOrganizations = (params = {}) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  return api.get('/organization', payload);
};

export const invitePartner = (payload) => {
  return api.post('/organization/invite', payload);
};

export const getInvites = (payload) => {
  return api.get('/organization/invite', payload);
};

export const removePartnerInvite = (id) => {
  return api.delete(`/organization/invite/${id}`);
};

export const updatePartnerStatus = (id, newStatus) => {
  return api.put(`/organization/${id}/relationship`, {
    status: newStatus,
  });
};

export const createAccountOnboarding = (id, payload = {}) => {
  return api.post(`/organization/${id}/payment_account`, payload);
};

export const fetchPaymentOnboarding = (id) => {
  return api.get(`/organization/${id}/payment_account/onboard`);
};

export const getAccountStatus = (id) => {
  return api.get(`/organization/${id}/payment_account`);
};

export const linkAccount = (id) => {
  return api.get(`/organization/${id}/payment_account/link_account`);
};

export const getBrokerSchema = (id) => {
  return api.get(`/organization/brokers/${id}`);
};
